import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import UpcomingSessionPage from "./UpcomingSessionPage";
import CompletedSessionPage from "./CompletedSessionPage";
import DateFormatting from "../../common_components/DateFormatting";


// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";


function SessionPage(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()
    const [loadingEvent, setLoadingEvent] = useState(true);
    const [session, setCompletedSession] = useState({});
    const [timezone, setTimezone] = useState("");
    const [sessionType, setSessionType] = useState("")
    const [hasScreener, setHasScreener] = useState(false);




    useEffect(() => {
        async function getEventDetails() {
            const result = await ScheduledEventAPI.one_mission_show_event({ missionId, sessionId, handleRedirect: navigate });

            if (result.success) {
                setCompletedSession(result.scheduled_event)
                setTimezone(result.timezone)
                const inFuture = DateFormatting.timeInFutureFromISOString(result.scheduled_event.start_time)
                setSessionType(inFuture ? "Upcoming" : "Completed")
                setHasScreener(result.has_screener)
                setLoadingEvent(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getEventDetails();
    }, []);

    function SwitchOutputByType() {
        if (sessionType === "Upcoming") {
            return <UpcomingSessionPage session={session} timezone={timezone} hasScreener={hasScreener} />
        } else {
            return <CompletedSessionPage session={session} timezone={timezone} hasScreener={hasScreener} />
        }
    }

    return (
        <>
            {loadingEvent ? <CenteredLoadingIcon /> : <SwitchOutputByType />}
        </>
    )
}


export default SessionPage;